import React, { useEffect } from 'react'
import { useQueryClient } from '@tanstack/react-query'

import { type MessageThread } from '../../../common/validations/residentMessageTimelineSchema'

import { useAPIGetResidentMessageThread } from 'api/apiHooks/useAPIGetResidentMessageThread'

export const MessageThreadViewDataLoader = ({
  children,
  messageThreadUuid,
}: {
  children: (thread: MessageThread) => React.ReactNode
  messageThreadUuid: string
}) => {
  const queryClient = useQueryClient()
  const { data } = useAPIGetResidentMessageThread(messageThreadUuid)

  useEffect(() => {
    queryClient.invalidateQueries({
      queryKey: ['resident-message-timeline'],
    })
  }, [data.id, queryClient])

  return children(data)
}
